import React from 'react';
import {connect} from 'react-redux';
import {PropTypes} from 'prop-types';
import DatePicker from '../Inputs/DatePicker';
import 'react-datepicker/dist/react-datepicker.css';

import {processLogin, pingLogin} from '../../Actions/Dashboard/login';

class Login extends React.Component {
    state = {
        email: '',
        pw: '',
        dob: '',
        startDate: null,
    }

    componentDidMount() {
        const {login, dispatch} = this.props;
        if (login) {
            dispatch(pingLogin(login.access_token, login.refresh_token));
        }
    }

    processLogin = (e) => {
        e.preventDefault();
        if (!this.state.dob) {
            this.setState({error: 'Invalid date'});
        } else if (this.state.email && this.state.dob && this.state.pw) {
            this.state.dob = this.state.dob.format('YYYY-MM-DD');
            this.props.dispatch(processLogin(this.state));
            this.setState({success: 'True'});
        } else {
            this.setState({error: 'Fields Required'});
        }

    };

    render() {
        return (
            <div className="wrap">
                <fieldset>
                    <h1 className="h2 justifycentre">Login to MyLiveWell</h1>
                    <p className="justifycentre">To access MyLiveWell please login below, if you have fogotten your
                        password you can <a href="/forgot-password">reset it here</a>.</p>
                    <p className="justifycentre">If you are not a member of MyLiveWell you can <a href="/register"
                                                                                                  onClick={() => document.querySelector('.js-comb-register').click()}>register here</a>.</p>

                    <form onSubmit={this.processLogin} className="form-register">
                        {this.props.loginerror ? <div className="form-register_question"><p
                            className="alert-error justifycentre">{this.props.loginerror}</p></div> : null}
                        {this.state.error ? (
                            <div className="form-register_question">
                                <p className="alert-error justifycentre">{this.state.error}</p>
                            </div>
                        ) : null}
                        <div className="form-register_question">
                            <label>
                                Email Address:
                                <input name="email" type="email" required value={this.state.email}
                                       onChange={e => this.setState({email: e.target.value})}/>
                            </label>
                        </div>
                        <div className="form-register_question">
                            <label>
                                Date of birth: </label>
                            <div className="form-register_input">

                                <DatePicker onChange={dob => this.setState({dob})}/>
                            </div>
                        </div>
                        <div className="form-register_question">
                            <label>
                                Password:
                                <input name="password" type="password" required value={this.state.pw}
                                       onChange={e => this.setState({pw: e.target.value})}/>
                            </label>
                        </div>
                        <div className="form-register_question justifycentre"><input type="submit" value="Login" className="button" /></div>
                    </form>
                </fieldset>
            </div>
        );
    }
}

Login.propTypes = {
    dispatch: PropTypes.func.isRequired,
    loginerror: PropTypes.string,
};

Login.defaultProps = {
    loginerror: '',
};

export default connect(state => ({
    loginerror: state.loginerror,
    login: state.login,
}), dispatch => ({dispatch}))(Login);



// WEBPACK FOOTER //
// ./src/Components/Login/index.jsx